export default __webpack_public_path__ + "static/8-31e43e471a8cb2bb6ba0a2b45b485eb8.png";